import "./scss/main.scss";
import articleFilter from './modules/flatpickr';
import faqFiter from "./modules/faqFilter";
import showMore from './modules/showMore';
import headerMenu from './modules/headerMenu';
import tariff from './modules/tariff';
const utmParser = (url) => ({
  getObject: () => {
    const params = new URLSearchParams(new URL(url, window.location.origin).search);
    return {
      campaign: params.get('utm_campaign') || '',
      content: params.get('utm_content') || '',
      medium: params.get('utm_medium') || '',
      source: params.get('utm_source') || '',
      term: params.get('utm_term') || ''
    };
  }
});
import { tooltipInit } from "./modules/tooltip";
import processLinks from "./modules/utmHandler";
import { PhoneMask } from "./modules/phoneMask";
import { cargoSpaceCalculator, ldmCalculator, boxVolumeCalculator, axleLoadCalculator } from "./modules/calculators";
import caseSlider from './modules/caseSlider';

const LANGUAGE_CODES = {
  RUSSIAN: 'ru',
  ENGLISH: 'en',
  UNAITED_STATES: 'us'
}

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// TAB FOCUS

export let focusableElements = [];
export let firstFocusableElement, lastFocusableElement;

export let prevFocusedElement;

export const getFocusableElements = (modal) => {
  return Array.from(
    modal.querySelectorAll('input:not([type="hidden"]), button, a, [tabindex]:not([tabindex="-1"])')
  ).filter(el => !el.disabled);
}

export const setupFocusTrap = (currModal, prevFcsdEl) => {
  if (prevFcsdEl) prevFocusedElement = prevFcsdEl;
  focusableElements = getFocusableElements(currModal);
  firstFocusableElement = focusableElements[1] || focusableElements[focusableElements.length - 1];
  lastFocusableElement = focusableElements[focusableElements.length - 1];
  firstFocusableElement.focus();
}

export const handleTab = (event, currModal) => {
  focusableElements = getFocusableElements(currModal);
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  if (event.key === 'Tab') {
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }
}
// TAB FOCUS

document.addEventListener("DOMContentLoaded", function () {
  let INITIAL_COUNTRY;
  if (CURRENT_LANGUAGE_CODE === LANGUAGE_CODES.ENGLISH) INITIAL_COUNTRY = LANGUAGE_CODES.UNAITED_STATES;
  else INITIAL_COUNTRY = CURRENT_LANGUAGE_CODE;

  const MODAL_ERROR = {
    ru: {
      REQUIRED: 'Обязательное поле',
      LIMIT_EXCEEDED: 'Превышение длины',
      INCORRECT_PHONE: 'Некорректный телефон',
      INCORRECT_EMAIL: 'Некорректная почта'
    },
    us: {
      REQUIRED: 'Required',
      LIMIT_EXCEEDED: 'Limit exceeded',
      INCORRECT_PHONE: 'Phone incorrect',
      INCORRECT_EMAIL: 'Email incorrect'
    }
  };
  const SUCCESS_MODAL_VISABILITY_CLASS = 'send-success__content-vision';
  const TRY_DEMO_MODAL_VISABILITY_CLASS = 'form-info__content-vision';

  const modal = document.querySelector('.js-modal');
  const openTryDemoModalButtons = document.querySelectorAll('.js-open-try-demo-modal');

  const successModal = document.querySelector('.js-success-modal');
  const successModalCloseButton = document.querySelector('.js-success-modal-close-btn');
  const tryDemoModal = document.querySelector('.js-try-demo-modal');
  const tryDemoModalCloseButtons = document.querySelectorAll('.js-try-demo-modal-close-btn');
  const tryDemoForm = document.querySelector('.js-form-info');
  const tryDemoSubmitButton = document.querySelector('.js-try-demo-submit-button');
  const reloadPageButtons = document.querySelectorAll('.js-reload-page-btn');

  let phoneInput, emailInput, fullNameInput, phoneWrapper;

  if (tryDemoForm) {
    phoneInput = tryDemoForm.querySelector('#phone');
    phoneWrapper = phoneInput.closest(".js-phone-input-wrapper");
    emailInput = tryDemoForm.querySelector('#email');
    fullNameInput = tryDemoForm.querySelector('#full-name');
  }
  const tryDemoCheckbox = document.querySelector('.js-form-info-checkbox');
  const tryDemoCheckmark = document.querySelector('.js-form-info-checkmark');

  // ----------------------------------
  let phoneMask;
  if (phoneInput) {
    phoneMask = new PhoneMask(phoneInput, {
      initialCountry: INITIAL_COUNTRY,
      language: INITIAL_COUNTRY,
      showValidation: true
    });
  }

  // ----------------------------------

  const handleOverLayClick = (event) => {
    if (event.target === event.currentTarget) {
      hideModal();
      closeSuccessModal();
      closeTryDemoModal();
    }
  }

  const handleEscClose = (event) => {
    if (event.key === 'Escape') {
      hideModal();
      closeSuccessModal();
      closeTryDemoModal();
    }
  }

  const showModal = () => {
    modal.style.display = 'flex';
    document.body.style.overflowY = 'hidden';
    modal.addEventListener('mouseup', handleOverLayClick);
    window.addEventListener('keydown', handleEscClose);
  }
  const hideModal = () => {
    modal.style.display = 'none';
    document.body.style.overflowY = 'auto';
    modal.removeEventListener('mouseup', handleOverLayClick);
    window.removeEventListener('keydown', handleEscClose);
  }

  const handleTryDemoTab = (event) => {
    handleTab(event, tryDemoModal);
  }

  const handleSuccessTab = (event) => {
    handleTab(event, successModal);
  }

  const closeTryDemoModal = (clearPrevFocused = true) => {
    hideModal();
    tryDemoModal.classList.add(TRY_DEMO_MODAL_VISABILITY_CLASS);
    if (prevFocusedElement) prevFocusedElement.focus();
    if (clearPrevFocused) prevFocusedElement = null;
    tryDemoModal.removeEventListener('keydown', handleTryDemoTab);
  }

  const openSuccessModal = () => {
    showModal();
    successModal.classList.remove(SUCCESS_MODAL_VISABILITY_CLASS);
    setupFocusTrap(successModal);
    successModal.addEventListener('keydown', handleSuccessTab);
  }

  const closeSuccessModal = () => {
    hideModal();
    successModal.classList.add(SUCCESS_MODAL_VISABILITY_CLASS);
    if (prevFocusedElement) prevFocusedElement.focus();
    prevFocusedElement = null;
    successModal.removeEventListener('keydown', handleSuccessTab);
  }

  const openTryDemoModal = (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    const componentId = button.getAttribute('component_id');
    const formComponentIdInput = tryDemoModal.querySelector('input[name="component_id"]');
    formComponentIdInput.value = componentId;
    showModal();
    tryDemoModal.classList.remove(TRY_DEMO_MODAL_VISABILITY_CLASS);
    setupFocusTrap(tryDemoModal, button);
    tryDemoModal.addEventListener('keydown', handleTryDemoTab);
  }

  const getCookie = (name) => {
    if (!document.cookie) return null;

    const cookie = document.cookie.split(';')
      .map(c => c.trim())
      .filter(c => c.startsWith(name + '='));

    if (cookie.length === 0) {
      return null;
    }

    return decodeURIComponent(cookie[0].split('=')[1]);
  }

  const getFormConfig = (form) => {
    const pageId = form.querySelector('input[name="page_id"]').value;
    const componentId = form.querySelector('input[name="component_id"]').value;

    return [pageId, componentId];
  }

  const currentUrl = window.location.href;
  const utm = utmParser(currentUrl).getObject();

  const handleTryDemoSubmit = async (event) => {
    event.preventDefault();

    if (validateForm(true)) {
      const url = 'api/feedback/';
      const [pageId, componentId] = getFormConfig(event.target);
      try {
        const formData = {};
        formData.phone = phoneMask ? phoneMask.getFormattedNumber() : phoneInput.value;
        formData.email = emailInput.value;
        formData.name = fullNameInput.value;
        formData.page_id = pageId;
        formData.component_id = componentId;
        formData.utm_campaign = utm.campaign;
        formData.utm_content = utm.content;
        formData.utm_medium = utm.medium;
        formData.utm_source = utm.source;
        formData.utm_term = utm.term;

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFTOKEN': getCookie('csrftoken'),
          },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          const result = await response.json();
          closeTryDemoModal(false);
          openSuccessModal();
          tryDemoForm.reset();
        } else if (response.status === 400) {
          const errorData = await response.json();
          if (errorData.phone) showError(phoneWrapper, errorData.phone[0])
        } else {
          console.error('Ошибка: ', response.status);
        }

      } catch (err) {
        console.error(err);
      }
    }
  }

  const isInputEmpty = (formInput) => {
    return formInput.value.trim() === ""
  }

  const showError = (inputWrapper, errorText) => {
    inputWrapper.classList.add("form-info__error");
    if (errorText) {
      const inputField = inputWrapper.closest('.form-info__input-field');
      const errorItem = inputField.querySelector('.form-info__error-field');
      errorItem.classList.add('form-info__error-field_visible');
      errorItem.textContent = errorText;
    }
  }

  const clearError = (inputWrapper) => {
    inputWrapper.classList.remove("form-info__error");
    const inputField = inputWrapper.closest('.form-info__input-field');
    if (inputField) {
      const errorItem = inputField.querySelector('.form-info__error-field');
      errorItem.classList.remove('form-info__error-field_visible');
      errorItem.textContent = '';
    }
  }

  const checkPhone = (isShowErr) => {
    if (!phoneInput) return true;
    
    if (phoneMask) {
      return phoneMask.validate(isShowErr);
    } else {
      // Fallback валидация если модуль не инициализирован
      let isValid = true;
      
      if (isInputEmpty(phoneInput)) {
        if (isShowErr) showError(phoneWrapper, MODAL_ERROR[INITIAL_COUNTRY].REQUIRED);
        isValid = false;
      } else {
        const digitsOnly = phoneInput.value.replace(/\D/g, "");
        if (!(digitsOnly.length >= 5 && digitsOnly.length <= 15)) {
          if (isShowErr) showError(phoneWrapper, MODAL_ERROR[INITIAL_COUNTRY].INCORRECT_PHONE);
          isValid = false;
        }
      }
      return isValid;
    }
  }

  const validateForm = (isShowErr) => {
    let isValid;

    // Проверка телефона
    isValid = checkPhone(isShowErr);

    // Проверка e-mail
    const emailWrapper = emailInput.closest(".form-info__input-email");
    if (isInputEmpty(emailInput)) {
      if (isShowErr) showError(emailWrapper, MODAL_ERROR[INITIAL_COUNTRY].REQUIRED)
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value.trim())) {
        if (isShowErr) showError(emailWrapper, MODAL_ERROR[INITIAL_COUNTRY].INCORRECT_EMAIL)
        isValid = false;
      } else {
        clearError(emailWrapper);
      }
    }

    // Проверка ФИО
    // const fullNameWrapper = fullNameInput.closest(".form-info__input-fio");
    // if (isInputEmpty(fullNameInput)) {
    //   if (isShowErr) showError(fullNameWrapper, MODAL_ERROR[INITIAL_COUNTRY].REQUIRED);
    //   isValid = false;
    // } else {
    //   clearError(fullNameWrapper);
    // }

    if (!tryDemoCheckbox.checked) {
      if (isShowErr) showError(tryDemoCheckmark);
      isValid = false;
    } else {
      clearError(tryDemoCheckmark);
    }

    return isValid;
  }

  const removeErrorOnInput = (inputElement, wrapperClass) => {
    inputElement.addEventListener("input", function () {
      const wrapper = inputElement.closest(wrapperClass);
      clearError(wrapper);
    });
  }

  const handleSubmitButtonStatus = () => {
    if (tryDemoSubmitButton) tryDemoSubmitButton.disabled = !validateForm(false);
  }

  const reloadPage = () => {
    location.reload();
  }

  // PhoneMask сам управляет валидацией и отображением ошибок для телефона
  if (emailInput) removeErrorOnInput(emailInput, ".form-info__input-email");
  // if (fullNameInput) removeErrorOnInput(fullNameInput, ".form-info__input-fio");
  handleSubmitButtonStatus();

  if (phoneInput && emailInput && fullNameInput) {
    [phoneInput, emailInput].forEach((input) => {
      input.addEventListener("input", handleSubmitButtonStatus);
    })
  }

  if (tryDemoCheckbox) tryDemoCheckbox.addEventListener('change', handleSubmitButtonStatus)

  if (openTryDemoModalButtons) {
    openTryDemoModalButtons.forEach((btn) => {
      btn.addEventListener('click', openTryDemoModal);
    })
  }
  if (tryDemoModalCloseButtons) {
    tryDemoModalCloseButtons.forEach((btn) => {
      btn.addEventListener('click', () => closeTryDemoModal());
    })
  }
  if (tryDemoCheckbox && tryDemoCheckmark) {
    tryDemoCheckmark.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        tryDemoCheckbox.checked = !tryDemoCheckbox.checked;
        tryDemoCheckbox.dispatchEvent(new Event('change'));
      }
    });
  }

  if (tryDemoForm) tryDemoForm.addEventListener('submit', handleTryDemoSubmit);

  if (successModalCloseButton) successModalCloseButton.addEventListener('click', closeSuccessModal);
  if (reloadPageButtons) reloadPageButtons.forEach((btn) => {
    btn.addEventListener('click', reloadPage);
  })
});

document.querySelectorAll('.rich-text table').forEach((table) => {
  if (!table.parentElement.classList.contains('rich-text__table-wrapper')) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rich-text__table-wrapper');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
});

document.querySelectorAll('p').forEach(p => {
  if (p.innerHTML.trim() === '' || p.innerHTML.trim() === '&nbsp;') {
    p.style.display = 'none';
  }
});

// Модалка с видеопроигрывателем на главном банере
document.addEventListener('DOMContentLoaded', () => {
  // Элементы DOM
  const modal = document.getElementById('videoModal');
  const videoPlayer = document.querySelector('.video-modal__player');
  const openButtons = document.querySelectorAll('.js-open-video-modal');
  const closeButton = document.querySelector('.video-modal__close');

  // Открытие модального окна
  openButtons.forEach(button => {
    button.addEventListener('click', () => {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Блокировка скролла
      videoPlayer.play();
    });
  });

  // Закрытие модального окна
  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = ''; // Восстановление скролла
    videoPlayer.pause();
    videoPlayer.currentTime = 0;
  }

  // Обработчики закрытия
  closeButton && closeButton.addEventListener('click', closeModal);

  // Закрытие по клику вне видео
  modal && modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Закрытие по Esc
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});

articleFilter();
faqFiter();
showMore();
headerMenu();
tariff();
tooltipInit();
//обработка ссылок (добавляем utm метки в href)
processLinks();
cargoSpaceCalculator();
ldmCalculator();
boxVolumeCalculator();
axleLoadCalculator();
caseSlider();
